import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import useDesktop from '../../../../hooks/useDesktop';
import Grid from '../../../../components/atomic/Grid';
import { useActiveProperty } from '../../../../store/hooks';
import {
  getPropertyType,
  hasValueEstimate,
} from '../../../../utils/properties';
import { PriceHistorySection } from '../Home/Overview/PriceHistorySection';
import PricePerSquareMeterSection from '../Home/Overview/PricePerSquareMeterSection';
import { PropertyRightsAndEconomySection } from '../Home/Overview/PropertyRightsAndEconomySection';
import PropertyEstimateSection from '../Home/Overview/PropertyEstimateSection';
import PageLayout from '../../../../components/layouts/WithHeader';
import { PropertyMarketEventsSection } from '../Home/Overview/PropertyMarketEventsSection';
import { propertyHasTotalSpaceData } from '../../../../api/helpers/property';
import { sGetActiveProperty } from '../../../../store/reducers/properties';

const PropertyFinancials = ({ activeProperty }) => {
  const isDesktop = useDesktop();
  const [landTypeProperty, setLandTypeProperty] = useState(false);
  const { property } = useActiveProperty();
  const [showMaxWidth, setShowMaxWidth] = useState(true);
  const [valueEstimateError, setValueEstimateError] = useState(false);
  const owned = activeProperty?.owned;
  useEffect(() => {
    if (getPropertyType(property) === 'Eiendom/tomt uten bygning') {
      setLandTypeProperty(true);
      setShowMaxWidth(true);
    } else if (
      !hasValueEstimate(property) &&
      propertyHasTotalSpaceData(property)
    ) {
      setShowMaxWidth(true);
    } else {
      setShowMaxWidth(false);
    }
  }, [property]);

  useEffect(() => {
    if (valueEstimateError) {
      setShowMaxWidth(true);
    }
  }, [valueEstimateError, showMaxWidth]);

  return (
    <PageLayout
      minFullHeight
      hideHeader
      lessMarginLeft={isDesktop}
      maxWidth="lg"
    >
      <Grid container spacing={isDesktop ? 6 : 2}>
        {!landTypeProperty && (
          <PropertyEstimateSection
            hasValueEstimateError={(val) => setValueEstimateError(val)}
          />
        )}
        {isDesktop && (
          <PropertyMarketEventsSection showMaxwidth={showMaxWidth} />
        )}
        {!landTypeProperty && <PriceHistorySection />}
        <PricePerSquareMeterSection />
        {!isDesktop && <PropertyMarketEventsSection />}
        {owned && <PropertyRightsAndEconomySection />}
      </Grid>
      <br />
      <br />
    </PageLayout>
  );
};

const mapStateToProps = (state) => ({
  activeProperty: sGetActiveProperty(state),
});

export default connect(mapStateToProps, null)(PropertyFinancials);
